module.exports = __webpack_public_path__ + "static/media/favicon.edc2e0c2.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicons/favicon.ico
// module id = 1127
// module chunks = 0